(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brand-laser-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  function initBrandSelectors(scope) {
    var roots = scope.querySelectorAll('[data-brand-selector]:not([data-brand-selector-ready])');

    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-brand-selector-ready', 'true');

      var buttons = root.querySelectorAll('[data-brand-choice]');
      var panels = root.querySelectorAll('[data-brand-detail]');
      var details = root.querySelector('.brand-selector__details');
      var mobile = window.matchMedia('(max-width: 699px)');

      function loadPrices(scope) {
        Array.prototype.forEach.call(scope.querySelectorAll('[data-brand-product-handle]:not([data-brand-product-loaded])'), function (link) {
          var price = link.querySelector('[data-brand-product-price]');
          var currency = link.getAttribute('data-brand-product-currency') || 'USD';
          var from = link.getAttribute('data-brand-product-from') || 'From';
          link.setAttribute('data-brand-product-loaded', 'loading');

          fetch(link.getAttribute('href') + '.js', { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) throw new Error('Product price unavailable');
              return response.json();
            })
            .then(function (product) {
              var amount = (product.price_min || product.price) / 100;
              var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(amount);
              price.textContent = from + ' ' + formatted;
              link.setAttribute('data-brand-product-loaded', 'true');
            })
            .catch(function () {
              link.setAttribute('data-brand-product-loaded', 'error');
            });
        });
      }

      function positionPanels() {
        if (mobile.matches) {
          Array.prototype.forEach.call(buttons, function (button) {
            var panel = root.querySelector('#' + button.getAttribute('aria-controls'));
            if (panel) button.insertAdjacentElement('afterend', panel);
          });
        } else {
          Array.prototype.forEach.call(panels, function (panel) { details.appendChild(panel); });
        }
      }

      function resetFamilies(panel) {
        var choices = panel.querySelector('[data-brand-family-choices]');
        var views = panel.querySelectorAll('[data-brand-family-view]');
        if (choices) choices.hidden = false;
        Array.prototype.forEach.call(views, function (view) { view.hidden = true; });
      }

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          var choice = button.getAttribute('data-brand-choice');
          Array.prototype.forEach.call(buttons, function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-expanded', active ? 'true' : 'false');
          });
          Array.prototype.forEach.call(panels, function (panel) {
            var active = panel.getAttribute('data-brand-detail') === choice;
            panel.hidden = !active;
            if (active) {
              resetFamilies(panel);
              loadPrices(panel);
            }
          });
          positionPanels();
        });
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-brand-family]'), function (button) {
        button.addEventListener('click', function () {
          var panel = button.closest('[data-brand-detail]');
          var choices = panel.querySelector('[data-brand-family-choices]');
          var selected = button.getAttribute('data-brand-family');
          choices.hidden = true;
          Array.prototype.forEach.call(panel.querySelectorAll('[data-brand-family-view]'), function (view) {
            var active = view.getAttribute('data-brand-family-view') === selected;
            view.hidden = !active;
            if (active) loadPrices(view);
          });
        });
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-brand-family-back]'), function (button) {
        button.addEventListener('click', function () { resetFamilies(button.closest('[data-brand-detail]')); });
      });

      positionPanels();
      Array.prototype.forEach.call(panels, function (panel) { if (!panel.hidden) loadPrices(panel); });
      if (mobile.addEventListener) mobile.addEventListener('change', positionPanels);
      else mobile.addListener(positionPanels);
    });
  }

  function start() { initBrandSelectors(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { initBrandSelectors(event.target); });
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-guidance-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCollectionGuides(scope) {
    var roots = scope.querySelectorAll('[data-collection-guide]:not([data-collection-guide-ready])');
    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-collection-guide-ready', 'true');
      var buttons = root.querySelectorAll('[data-collection-guide-choice]');
      var panels = root.querySelectorAll('[data-collection-guide-panel]');
      var details = root.querySelector('[data-collection-guide-details]');
      var mobile = window.matchMedia('(max-width: 699px)');

      function positionPanels() {
        if (mobile.matches) {
          Array.prototype.forEach.call(buttons, function (button) {
            var panel = root.querySelector('#' + button.getAttribute('aria-controls'));
            if (panel) button.insertAdjacentElement('afterend', panel);
          });
        } else {
          Array.prototype.forEach.call(panels, function (panel) { details.appendChild(panel); });
        }
      }

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          var choice = button.getAttribute('data-collection-guide-choice');
          Array.prototype.forEach.call(buttons, function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-expanded', active ? 'true' : 'false');
          });
          Array.prototype.forEach.call(panels, function (panel) {
            panel.hidden = panel.getAttribute('data-collection-guide-panel') !== choice;
          });
          positionPanels();
        });
      });

      positionPanels();
      if (mobile.addEventListener) mobile.addEventListener('change', positionPanels);
      else mobile.addListener(positionPanels);
    });
  }

  function start() { initCollectionGuides(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { initCollectionGuides(event.target); });
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["haotian-engraver-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  function initHaotianSelectors(scope) {
    var roots = scope.querySelectorAll('[data-haotian-selector]:not([data-haotian-selector-ready])');

    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-haotian-selector-ready', 'true');

      var buttons = root.querySelectorAll('[data-haotian-choice]');
      var panels = root.querySelectorAll('[data-haotian-detail]');
      var details = root.querySelector('.haotian-selector__details');
      var mobile = window.matchMedia('(max-width: 699px)');

      function positionPanels() {
        if (mobile.matches) {
          Array.prototype.forEach.call(buttons, function (button) {
            var panel = root.querySelector('#' + button.getAttribute('aria-controls'));

            if (panel) {
              button.insertAdjacentElement('afterend', panel);
            }
          });
        } else {
          Array.prototype.forEach.call(panels, function (panel) {
            details.appendChild(panel);
          });
        }
      }

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          var choice = button.getAttribute('data-haotian-choice');

          Array.prototype.forEach.call(buttons, function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-expanded', active ? 'true' : 'false');
          });

          Array.prototype.forEach.call(panels, function (panel) {
            panel.hidden = panel.getAttribute('data-haotian-detail') !== choice;
          });

          positionPanels();
        });
      });

      positionPanels();

      if (mobile.addEventListener) {
        mobile.addEventListener('change', positionPanels);
      } else {
        mobile.addListener(positionPanels);
      }
    });
  }

  function start() {
    initHaotianSelectors(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHaotianSelectors(event.target);
  });
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["laser-engraver-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  function initLaserGuides(scope) {
    var roots = scope.querySelectorAll('[data-laser-guide]:not([data-laser-guide-ready])');

    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute('data-laser-guide-ready', 'true');
      var buttons = root.querySelectorAll('[data-laser-guide-choice]');
      var panels = root.querySelectorAll('[data-laser-guide-panel]');
      var details = root.querySelector('[data-laser-guide-details]');
      var mobile = window.matchMedia('(max-width: 699px)');

      function positionPanels() {
        if (mobile.matches) {
          Array.prototype.forEach.call(buttons, function (button) {
            var panel = root.querySelector('#' + button.getAttribute('aria-controls'));
            if (panel) button.insertAdjacentElement('afterend', panel);
          });
        } else {
          Array.prototype.forEach.call(panels, function (panel) { details.appendChild(panel); });
        }
      }

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          var choice = button.getAttribute('data-laser-guide-choice');
          Array.prototype.forEach.call(buttons, function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-expanded', active ? 'true' : 'false');
          });
          Array.prototype.forEach.call(panels, function (panel) {
            panel.hidden = panel.getAttribute('data-laser-guide-panel') !== choice;
          });
          positionPanels();
        });
      });

      positionPanels();
      if (mobile.addEventListener) mobile.addEventListener('change', positionPanels);
      else mobile.addListener(positionPanels);
    });
  }

  function start() { initLaserGuides(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) { initLaserGuides(event.target); });
}());
  } catch(e) { console.error(e); }
})();

})();
